import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Vue from 'vue'

let baseParams = {
  pagination: false
}

function errorAlert ({ commit }, e) {
  commit(types.TOGGLE_LOADING)
  Vue.prototype.$Swal({
    type: 'error',
    title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
    text: e.message,
    showConfirmButton: true,
    timer: 6000
  })
  console.log(e.message)
}

const getUserDataItems = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'user_datas/list'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_USERDATA_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

// TODO: dodać nowe operacje do pobierania list (url = .../list) j/w
const getItemTypes = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_s_b_item_types'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ITEMTYPES_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const getItemBrands = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_s_b_item_brands'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ITEMBRANDS_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const getItemCategories = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_s_b_items_categories'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ITEMCATEGORIES_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const getPriceGroups = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_s_b_price_groups'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_PRICEGROUPS_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const getMeasures = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_s_b_measures'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_MEASURES_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const getVatRates = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_s_b_vat_rates'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_VATRATES_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const getCases = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let url = 'e_x_c_m_cases'
  params = Object.assign(params, baseParams)
  let page = addParamsToQuery(url, params)
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_CASES_ITEMS, data['hydra:member'])
    })
    .catch((e) => {
      errorAlert({ commit }, e)
    })
}

const reset = ({ commit }) => {
  commit(types.RESET)
}

export { getUserDataItems, getItemTypes, getItemBrands, getItemCategories, getPriceGroups, getMeasures, getVatRates, getCases, reset }
